<div
  #container
  class="flex flex-col gap-2.5"
  [class.containerDiv]="settingOption !== 'grouped'"
  [class.finishing]="settingOption === 'finishing' || settingOption === 'grouped'"
>
  <!-- TYPE TITLE WITHOUT BUTTON -->
  <div
    *ngIf="selectorType === 'buttons' && settings[settingOption].title"
    class="header flex flex-row items-center justify-start"
  >
    <span class="title mr-4">{{ settings[settingOption].title }}</span>
    <ion-icon
      [id]="'tooltip-icon-' + settingOption"
      class="tooltip-icon"
      [color]="color"
      src="assets/icon/info.svg"
    ></ion-icon>
    <ion-popover
      [trigger]="'tooltip-icon-' + settingOption"
      class="info-popover"
      triggerAction="click"
      side="right"
      showBackdrop="true"
      animated="true"
    >
      <ng-template>
        <app-tooltip-info-color *ngIf="settingOption == 'color'"></app-tooltip-info-color>
        <app-tooltip-info-page-size *ngIf="settingOption == 'pageSize'"></app-tooltip-info-page-size>
        <app-tooltip-info-paper-weight *ngIf="settingOption == 'paperWeight'"></app-tooltip-info-paper-weight>
        <app-tooltip-info-two-sided *ngIf="settingOption === 'twoSided'"></app-tooltip-info-two-sided>
        <app-tooltip-info-page-orientation
          *ngIf="settingOption === 'pageOrientation'"
        ></app-tooltip-info-page-orientation>
        <app-tooltip-info-pages-per-sheet *ngIf="settingOption === 'pagesPerSheet'"></app-tooltip-info-pages-per-sheet>
        <app-tooltip-info-page-turn
          *ngIf="settingOption === 'pageTurn'"
          [pageOrientation]="
            settings.pageOrientation.selected ===
            this.appService.getSelectedIndexForOption(Settings.PAGE_ORIENTATION, { value: 'portrait' })
              ? 'vertical'
              : 'horizontal'
          "
        ></app-tooltip-info-page-turn>
      </ng-template>
    </ion-popover>
  </div>
  <!-- TYPE WITH BUTTON ONLY -->
  <div
    *ngIf="selectorType === 'buttons'"
    class="force-justify-start flex w-full flex-row flex-wrap items-end justify-between gap-y-1"
    [class.force-justify-start]="settingOption === 'grouped'"
  >
    <ng-container *ngIf="!settings[settingOption].categorized; else categories">
      <ng-container *ngFor="let option of settings[settingOption].options; let i = index">
        <div
          *ngIf="!option.hidden"
          class="flex flex-col justify-center"
          [ngStyle]="{
            width: option?.extraData?.isBindingWithCoverLaminated
              ? 'calc(calc(' + (isMobile && option.sizeMobile ? option.sizeMobile : option.size) + '/ 12) * 100%)'
              : 'calc(calc(' +
                (isMobile && option.sizeMobile ? option.sizeMobile : option.size) +
                '/ 12) * 100% - 5px)',
          }"
        >
          <!-- IMAGEN TITLE TOOLTIP Y SUBTITLE -->
          <div
            class="option-tooltip-wrapper"
            [class.with-badge]="!!option.badge"
            tooltipClass="warning-tooltip"
            contentType="html"
            maxWidth="300px"
            #warningTooltip="tooltip"
            [tooltip]="getTooltip(option, i)"
            (mouseenter)="centerTooltip(warningTooltip, $event)"
          >
            <!-- BADGE OPCIONAL (p. ej. 10% dto.) -->
            <div *ngIf="option.badge" class="option-badge">{{ option.badge }}</div>
            <ion-button
              expand="block"
              class="flex-grow-0"
              (click)="selectOption(i, $event)"
              [class.selected]="isSelected(i)"
              [ngClass]="{
                'finishing-selected': settingOption === 'finishing' || settingOption === 'grouped',
                'general-selected': settingOption !== 'finishing' && settingOption !== 'grouped',
              }"
              [disabled]="isDisabled(i)"
            >
              <!-- AGRUPAR CONTENERDOR DE TITULO + CONTENEDOR OPCIONAL -->
              <div class="flex w-full flex-col space-y-4">
                <!-- CONTENEDOR DE LA IMAGEN TITULO TOOLTIP Y SUBTITLE -->
                <div
                  class="w-100 flex flex-row items-center justify-center gap-1.5 py-1"
                  [class.force-justify-start]="option.image"
                >
                  <!-- ICONO DEL BOTON | SI TIENE -->
                  <ion-icon *ngIf="option.image" class="image-option" [src]="option.image"></ion-icon>
                  <!-- ANIMACION DEL BOTON | SI TIENE -->
                  <ng-lottie *ngIf="option.lottie" [options]="getLottieOptions(option.lottie)"></ng-lottie>
                  <!-- TITULO Y SUBTITULO + TOOLTIP | SI TIENE -->
                  <div class="flex flex-col items-center justify-center gap-1.5" [class.w-full]="option?.title">
                    <!-- TITULO + TOOLTIP -->
                    <div
                      class="flex w-full flex-row items-center"
                      [ngClass]="option?.image ? 'justify-between' : 'justify-center'"
                    >
                      <span class="title text-start">{{ option?.title }}</span>
                      <!-- TOOLTIP DEL GRAPADO -->
                      <ng-container *ngIf="option.value === Finishing.STAPLED">
                        <ion-icon
                          [id]="'tooltip-icon-cover-stapling'"
                          class="tooltip-icon"
                          src="assets/icon/info.svg"
                        ></ion-icon>
                        <ion-popover
                          [trigger]="'tooltip-icon-cover-stapling'"
                          class="info-popover"
                          triggerAction="hover"
                          showBackdrop="true"
                          animated="true"
                        >
                          <ng-template>
                            <app-tooltip-info-stapling></app-tooltip-info-stapling>
                          </ng-template>
                        </ion-popover>
                      </ng-container>
                      <!-- TOOLTIP DEL ENCUADERNADO -->
                      <ng-container
                        *ngIf="option.value === Finishing.BINDING && !option?.extraData?.isBindingWithCoverLaminated"
                      >
                        <ion-icon
                          [id]="'tooltip-icon-cover-binding'"
                          class="tooltip-icon"
                          src="assets/icon/info.svg"
                        ></ion-icon>
                        <ion-popover
                          [trigger]="'tooltip-icon-cover-binding'"
                          class="info-popover"
                          triggerAction="hover"
                          showBackdrop="true"
                          animated="true"
                        >
                          <ng-template>
                            <app-tooltip-info-binding
                              [coverLaminated]="option?.extraData?.isBindingWithCoverLaminated"
                              [settings]="settings"
                            ></app-tooltip-info-binding>
                          </ng-template>
                        </ion-popover>
                      </ng-container>
                    </div>
                    <!-- SUBTILTE -->
                    <div *ngIf="!isHidden(i)" class="sub-title w-100" [class.text-start]="option.image">
                      <span> {{ buttonSubtitle(option, i) }}</span>
                    </div>
                  </div>
                </div>
                <!-- ENCUADERNADO Y ENCUADERANDO CON PORTADA -->
                <ng-container *ngIf="settingOption == 'finishing' && option.value === Finishing.BINDING">
                  <div *ngIf="isBindingSelected(option)">
                    <div class="binding-options-container flex flex-col gap-2.5">
                      <!-- INDIVIDUAL + AGRUPADO -->
                      <div class="flex flex-row">
                        <!-- FUNCION RECURSIVA -->
                        <app-options-button
                          class="w-100"
                          [settings]="settings"
                          settingOption="grouped"
                          [printProduct]="printProduct"
                          (optionSelect)="optionSelect.emit($event)"
                        ></app-options-button>
                      </div>
                      <!-- OPCIONES DE ANILLAS + TAPA DELANTERA + TAPA TRASERA -->
                      <app-binding-options
                        [settings]="settings"
                        [printProduct]="printProduct"
                        [qty]="printProduct.qty"
                        (optionSelect)="optionSelect.emit($event)"
                        [additionalClasses]="{
                          'finishing-selected':
                            isSelected(i) && (settingOption === 'finishing' || settingOption === 'grouped'),
                          'general-selected':
                            isSelected(i) && settingOption !== 'finishing' && settingOption !== 'grouped',
                        }"
                      >
                      </app-binding-options>
                    </div>
                  </div>
                </ng-container>

                <!-- OPCION PLASTIFICADO -->
                <ng-container
                  *ngIf="
                    option.value === Finishing.LAMINATED &&
                    settingOption == 'finishing' &&
                    printProduct.product.printingGroup.printSettings.finishing === Finishing.LAMINATED
                  "
                >
                  <app-lamination-options
                    [settings]="settings"
                    (optionSelect)="optionSelect.emit($event)"
                    [styleType]="'new'"
                  ></app-lamination-options>
                </ng-container>
              </div>
            </ion-button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <!--TODO refactorizar codigo para no repetir-->
  <ng-template #categories>
    <div
      class="w-100 group flex flex-row flex-wrap items-end justify-between"
      *ngFor="let group of settings[settingOption].categorizedOptions as groups; let i = index"
    >
      <ng-container *ngFor="let option of group.options; let j = index">
        <div
          *ngIf="!option.hidden"
          class="flex flex-col justify-center"
          [ngStyle]="{
            width: option?.extraData?.isBindingWithCoverLaminated
              ? 'calc(calc(' + (isMobile && option.sizeMobile ? option.sizeMobile : option.size) + '/ 12) * 100%)'
              : 'calc(calc(' +
                (isMobile && option.sizeMobile ? option.sizeMobile : option.size) +
                '/ 12) * 100% - 5px)',
          }"
        >
          <span
            *ngIf="j === 0"
            class="category-title"
            [class.w-100]="(isMobile && option.sizeMobile >= 12) || (!isMobile && option.size >= 12)"
          >
            {{ getSettingCategoryText(group) }}
          </span>
          <!-- IMAGEN TITLE TOOLTIP Y SUBTITLE -->
          <div tooltipClass="warning-tooltip" [tooltip]="getTooltip(option, option.index)">
            <ion-button
              expand="block"
              class="flex-grow-0"
              (click)="selectOption(option.index, $event)"
              [class.selected]="isSelected(option.index)"
              [ngClass]="{
                'finishing-selected': settingOption === 'finishing' || settingOption === 'grouped',
                'general-selected': settingOption !== 'finishing' && settingOption !== 'grouped',
              }"
              [disabled]="isDisabled(option.index)"
            >
              <!-- AGRUPAR CONTENERDOR DE TITULO + CONTENEDOR OPCIONAL -->
              <div class="flex w-full flex-col space-y-4">
                <!-- CONTENEDOR DE LA IMAGEN TITULO TOOLTIP Y SUBTITLE -->
                <div
                  class="w-100 flex flex-row items-center justify-center gap-1.5 py-1"
                  [class.force-justify-start]="option.image"
                >
                  <!-- ICONO DEL BOTON | SI TIENE -->
                  <ion-icon *ngIf="option.image" class="image-option" [src]="option.image"></ion-icon>
                  <!-- ANIMACION DEL BOTON | SI TIENE -->
                  <ng-lottie *ngIf="option.lottie" [options]="getLottieOptions(option.lottie)"></ng-lottie>
                  <!-- TITULO Y SUBTITULO + TOOLTIP | SI TIENE -->
                  <div class="flex flex-col items-center justify-center gap-1.5" [class.w-full]="option?.title">
                    <!-- TITULO + TOOLTIP -->
                    <div
                      class="flex w-full flex-row items-center"
                      [ngClass]="option?.image ? 'justify-between' : 'justify-center'"
                    >
                      <span class="title text-start">{{ option?.title }}</span>
                      <!-- TOOLTIP DEL GRAPADO -->
                      <ng-container *ngIf="option.value === Finishing.STAPLED">
                        <ion-icon
                          [id]="'tooltip-icon-cover-stapling'"
                          class="tooltip-icon"
                          src="assets/icon/info.svg"
                        ></ion-icon>
                        <ion-popover
                          [trigger]="'tooltip-icon-cover-stapling'"
                          class="info-popover"
                          triggerAction="hover"
                          showBackdrop="true"
                          animated="true"
                        >
                          <ng-template>
                            <app-tooltip-info-stapling></app-tooltip-info-stapling>
                          </ng-template>
                        </ion-popover>
                      </ng-container>
                      <!-- TOOLTIP DEL ENCUADERNADO -->
                      <ng-container
                        *ngIf="option.value === Finishing.BINDING && !option?.extraData?.isBindingWithCoverLaminated"
                      >
                        <ion-icon
                          [id]="'tooltip-icon-cover-binding'"
                          class="tooltip-icon"
                          src="assets/icon/info.svg"
                        ></ion-icon>
                        <ion-popover
                          [trigger]="'tooltip-icon-cover-binding'"
                          class="info-popover"
                          triggerAction="hover"
                          showBackdrop="true"
                          animated="true"
                        >
                          <ng-template>
                            <app-tooltip-info-binding
                              [coverLaminated]="option?.extraData?.isBindingWithCoverLaminated"
                              [settings]="settings"
                            ></app-tooltip-info-binding>
                          </ng-template>
                        </ion-popover>
                      </ng-container>
                    </div>
                    <!-- SUBTILTE -->
                    <div *ngIf="!isHidden(i)" class="sub-title w-100" [class.text-start]="option.image">
                      <span> {{ buttonSubtitle(option, i) }}</span>
                    </div>
                  </div>
                </div>
                <!-- ENCUADERNADO Y ENCUADERANDO CON PORTADA -->
                <ng-container
                  *ngIf="
                    settingOption == 'finishing' &&
                    [Finishing.BINDING, Finishing.BINDING_LAMINATED].includes(option.value)
                  "
                >
                  <div *ngIf="isBindingSelected(option)">
                    <div class="binding-options-container flex flex-col gap-2.5">
                      <!-- INDIVIDUAL + AGRUPADO -->
                      <div class="flex flex-row">
                        <!-- FUNCION RECURSIVA -->
                        <app-options-button
                          class="w-100"
                          [settings]="settings"
                          settingOption="grouped"
                          [printProduct]="printProduct"
                          (optionSelect)="optionSelect.emit($event)"
                        ></app-options-button>
                      </div>
                      <!-- OPCIONES DE ANILLAS + TAPA DELANTERA + TAPA TRASERA -->
                      <app-binding-options
                        [settings]="settings"
                        [printProduct]="printProduct"
                        [qty]="printProduct.qty"
                        (optionSelect)="optionSelect.emit($event)"
                        [additionalClasses]="{
                          'finishing-selected':
                            isSelected(option.index) && (settingOption === 'finishing' || settingOption === 'grouped'),
                          'general-selected':
                            isSelected(option.index) && settingOption !== 'finishing' && settingOption !== 'grouped',
                        }"
                      >
                      </app-binding-options>
                    </div>
                  </div>
                </ng-container>

                <!-- OPCION PLASTIFICADO -->
                <ng-container
                  *ngIf="
                    option.value === Finishing.LAMINATED &&
                    settingOption == 'finishing' &&
                    printProduct.product.printingGroup.printSettings.finishing === Finishing.LAMINATED
                  "
                >
                  <app-lamination-options
                    [settings]="settings"
                    (optionSelect)="optionSelect.emit($event)"
                    [styleType]="'new'"
                  ></app-lamination-options>
                </ng-container>
              </div>
            </ion-button>
          </div>
        </div>
      </ng-container>
      <hr *ngIf="i !== groups.length - 1" />
    </div>
  </ng-template>
  <!-- TYPE CHECK -->
  <div *ngIf="selectorType === 'check'" class="flex flex-row items-stretch justify-between">
    <span
      class="title"
      [ngClass]="{
        'title-black': settings[settingOption].title === 'Es una programación didáctica',
      }"
    >
      {{ settings[settingOption].title }}
    </span>
    <ion-toggle
      (ionChange)="selectOptionCheck($event)"
      [checked]="settings[settingOption].selected === 1"
      aria-label="Dark toggle"
      class="toggle"
    ></ion-toggle>
  </div>
</div>
